module.exports = __webpack_public_path__ + "img/greenShadow.88bba756.webp";